<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    title="Wniosek KO"
    class="modal-big"
    :submit-button="step === 1 ? 'Podgląd' : 'Wyślij do MDOK'"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="nextStep"
    @close="close"
  >
    <ko-report v-if="step === 1" :schema="$schema" />

    <div v-if="step === 2" class="proposal-preview">
      <iframe ref="iframe" :srcdoc="preview" :style="{ height: iframeHeight }" />
    </div>

    <template slot="footer">
      <div class="w-100 d-flex justify-content-between">
        <w-button text="Anuluj" class="btn-danger" @click="close" />

        <div class="d-flex">
          <w-button text="Wróć" class="btn-secondary mr-5" :disabled="step === 1" @click="step = 1" />

          <w-button v-if="step === 2" text="Wyślij do MDOK" class="btn-primary" @click="nextStep" />

          <w-button v-else text="Podgląd" class="btn-primary" @click="nextStep" />
        </div>
      </div>
    </template>
  </w-modal>
</template>

<script>
import { schemaMixin } from '@witkac/jschema';
import { mapState } from 'vuex';

import KoReport from '@/components/forms/actionData/KoReport.vue';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { iframeMixin } from '@/mixins/iframe';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import { koResource } from '@/resources/ko.resource';
import schema from '@/schemas/koProposal.schema';
import { getPaymentPackDetails } from '@/utils/paymentList';
import { serverError } from '@/utils/serverError';

// @vuese
// Modal dodania
// @group
export default {
  components: { KoReport },
  mixins: [iframeMixin(), notificationsMixin, modalMixin, schemaMixin],
  schema,
  external: {
    payments: []
  },

  data() {
    return { model: {}, step: 1, preview: '' };
  },

  computed: {
    ...mapState({
      payments: state => state.payment.list
    }),
    paymentPackId() {
      return parseInt(this.$route.params.packId);
    }
  },

  beforeMount() {
    this.$external.payments = this.payments;
  },

  methods: {
    nextStep() {
      if (this.$schema.$validateAll().length) {
        this.notifyError(Errors.FORM_CORRECT_ERRORS);
        return;
      }
      if (this.step === 1) {
        return this.openPreview();
      }

      return this.submit();
    },

    openPreview() {
      koResource
        .previewProposal({ packId: this.paymentPackId, data: this.$schema.$getData() })
        .then(preview => {
          this.preview = preview;
          this.step = 2;
        })
        .catch(err => this.notifyError(serverError(err)));
    },

    submit() {
      koResource
        .sendKoProposalToMdok({ packId: this.paymentPackId, data: this.$schema.$getData() })
        .then(() => {
          this.notifySuccess(Successes.KO_PROPOSAL_SENT);
          getPaymentPackDetails(this.$route);
          this.close();
        })
        .catch(err => this.notifyError(serverError(err)));
    }
  }
};
</script>

<style>
.proposal-preview {
  border: 1px solid black;
}

.proposal-preview iframe {
  width: 99%;
  border: none;
}
</style>
